module.exports = __webpack_public_path__ + "media/07 in memory of sb.e25e5f61.mp3";